var getUrlParameter=function r(t){var i,a,e=decodeURIComponent(window.location.search.substring(1)).split("&");for(a=0;a<e.length;a++)if((i=e[a].split("="))[0]===t)return void 0===i[1]||i[1]};
const swiper = new Swiper('.swiper', {
  // Optional parameters
  loop: true,

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
});

let optionNumber = 1;
let optionNumberFields = ['.option-color .form__label','.option-style .form__label','.option-field .form__label','.option-size .form__label'];
for (o=0;o<optionNumberFields.length;o++){
  document.querySelectorAll(optionNumberFields[o]).forEach((field) => {
    let label = document.createElement("span");
    label.classList.add('field-num');
    label.innerText = optionNumber;
    field.prepend(label);
    optionNumber++;
  });
}
/*
if($('.option-color .form__label').length){
  $('.option-color .form__label').prepend('<span class="field-num">' + optionNumber + ' </span>');
  optionNumber++;
}
if($('.option-style .form__label').length){
  $('.option-style .form__label').prepend('<span class="field-num">' + optionNumber + ' </span>');
  optionNumber++;
}
$('.option-field .form__label').each(function(){
    $(this).prepend('<span class="field-num">' + optionNumber + ' </span>');
    optionNumber++;
});

$('.option-size .form__label').prepend('<span class="field-num">' + optionNumber + ' </span>');
*/
let checkForm = setInterval(function(){
	if ( $('#infiniteoptions-container .spb-label-tooltip label').length ){
      
      clearInterval(checkForm);
      
    /*
      let specialReqOld = $('input[name="properties[Special Requests (Optional)]"]');
        if(specialReqOld){
              let specialReqOldId = specialReqOld.attr('id');
            specialReqOld.parent().parent().parent().attr('x-data','{show:false}');
            $('[for="'+specialReqOldId+'"]').html("<span class='special-request-label'>Click here to add special requests</span>").attr({'x-on:click':'show=!show'})
              let specialReq = $(`<textarea id="${specialReqOldId}" x-show="show" name="properties[Special Requests (Optional)]" class="spb-productdescfont spb-productoptiontextcolor spb-productoptionbackground" placeholder="Any text changes you want to make, visuals you want to add, colors or additional elements you want to include."></textarea>`);
              specialReq.insertAfter(specialReqOld);
              specialReqOld.remove();
            
        }
      if($('.option-color .form__label').length){
        $('.option-color .form__label').prepend('<span class="field-num">' + optionNumber + ' </span>');
        optionNumber++;
      }
      if($('.option-style .form__label').length){
        $('.option-style .form__label').prepend('<span class="field-num">' + optionNumber + ' </span>');
        optionNumber++;
      }
      $('#infiniteoptions-container .spb-label-tooltip label').each(function(){
        //console.log(optionNumber ,$(this).parent().next().find('input').prop('disabled') );
          $(this).prepend('<span class="field-num">' + optionNumber + ' </span>');
          optionNumber++;
      });
      
      $('.option-size .form__label').prepend('<span class="field-num">' + optionNumber + ' </span>');
      var requiredFields = $('#infiniteoptions-container input[required]');
      if(requiredFields.length){
                  $('.product-form__submit').addClass('can-personalize');
                  $('.product-form__buttons-atc').addClass('hidden');
                  $('.product-form__buttons-personalize').removeClass('hidden');
      }
      requiredFields.change(function(){
          requiredFields.each(function(){
              if( $(this).val() == '' ){
                  $('.product-form__buttons-atc').addClass('hidden');
                  $('.product-form__buttons-personalize').removeClass('hidden');
                $('.product-form__buttons-personalize-text').addClass('hidden');
                  return false;
              }else{
                  $('.product-form__buttons-personalize').addClass('hidden');
                  $('.product-form__buttons-atc').removeClass('hidden');
                $('.product-form__buttons-personalize-text').removeClass('hidden');
              }
          });
      });
      
      $('.product-form__submit').on('click', function () {
        requiredFields.each(function(){
          if( $(this).val() == '' ){
            $(this).scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
            return false;
          }
        });
      });
      
      */
      $('#infiniteoptions-container').remove();
    }
},100);

var requiredFields = $('.option-set [required]');
/*
if(requiredFields.length){
  $('.product-form__submit').addClass('can-personalize');
  $('.product-form__buttons-atc').addClass('hidden');
  $('.product-form__buttons-personalize').removeClass('hidden');
}
$('.option-set').on('change', '[required]' ,function(){
    requiredFields.each(function(){
        if( $(this).val() == '' ){
            $('.product-form__buttons-atc').addClass('hidden');
            $('.product-form__buttons-personalize').removeClass('hidden');
          $('.product-form__buttons-personalize-text').addClass('hidden');
            return false;
        }else{
            $('.product-form__buttons-personalize').addClass('hidden');
            $('.product-form__buttons-atc').removeClass('hidden');
          $('.product-form__buttons-personalize-text').removeClass('hidden');
        }
    });
});
*/
$('.product-form__submit').on('click', function (e) {
  var foundError = false;
  $('.option-set [required]').each(function(){
    if( $(this).val() == '' ){
      e.preventDefault();
      $(this).addClass('error');
      if(!foundError){
        let field = $(this)[0];
        field.focus();
        field.style.scrollMarginTop= (document.querySelector('.section-header').scrollHeight + 30 ) + 'px';
        field.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
      }
      foundError = true;
      //return false;
    }else{
      $(this).removeClass('error');
    }
  });
});
if( $('body').hasClass('product') ){
  $(function() {
        var header = $('header.header').height();
        var product_form = $(".product-form");
	    var offset = product_form.offset();
        var height = product_form.height();
	    var topPadding = 150;
	    $(window).scroll(function() {
	        if ($(this).scrollTop() > offset.top + height +300 ) {
	            product_form.addClass('up');
	        } else {
	            product_form.removeClass('up');
	        };
	    });
	});
    $('.product__info-wrapper .shopify-app-block').appendTo('.product_header');
    let desktop_move = ['.p-risk-free', '.product-uvps-wrap', '.section-proof'];
    let desktop_left_sidebar = $('<div class="desktop-only product__media-extra"></div>');
    for(dm=0;dm<desktop_move.length;dm++){
        let elm = $(desktop_move[dm]).clone();
        if( desktop_move[dm] == '.section-proof'){
          elm.find('.splide__pagination').empty();
        }
        $(desktop_move[dm]).addClass('mobile-only');
        desktop_left_sidebar.append(elm);
    }
    $('.product__media-wrapper').append(desktop_left_sidebar);
    $(window).resize();

  let find_easytabs = setInterval(function(){
    if($('.easytabs-content-item').length){
      clearInterval(find_easytabs);
      //let rscript = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
      //let easytabs = $('.easytabs-container').clone().html().replace(rscript, '');
      //$('.easytabs-container').replaceWith(easytabs);
      
      $('.easytabs-contents').attr({"x-data":"{ tabOpen: 0, expanded: null }"});
      $('.easytabs-content-item').each(function(index){
        let tab = $(this);
        tab.find('.easytabs-header-text').text(tab.find('.easytabs-header-text').text().split(' ').join(''));

        tab.find('.faq-item').each(function(index){
          let faq = $(this);
          faq.attr({":class":`expanded == ${index} ? 'open' : 'closed'`});
          faq.find('.faq-title').attr({"x-on:click":`expanded = expanded == ${index} ? null : ${index}`});
          faq.find('.faq-content-wrap').attr({"x-collapse":"","x-show":`expanded == ${index}`})
        });
        
        tab.attr({"class":"easytab-content-item",":class":`tabOpen == ${index} ? 'open' : 'closed'`});
        tab.find('.easytabs-accordion-item').off('click');
        tab.find('.easytabs-accordion-item').attr({"class":"easytab-accordion-item","x-on:click":`tabOpen = tabOpen == ${index} ? null : ${index}`});
        tab.find('.easytabs-content-holder').attr({"class":"easytab-content-holder","x-collapse":"","x-show":`tabOpen == ${index}`})
      });
      
    }
  },300);
  /*
  $('.size-guide-toggle').on('click',function(){
    $(this).closest('.option-size-2').toggleClass('open');
  });
  let first_size = $('.option-size .size-guide-item').first().attr('data-preview');
  $('.size-guide-preview').html(`<img src="${first_size}"/>`);
  $('.option-size').on('click', 'label', function(){
    let text = $(this).find('.option-value').text().trim();
    let image_src = $(`.size-guide-item[data-size='${text}']`).attr('data-preview');
    $('.size-guide-preview').html(`<img src="${image_src}"/>`);
  })
  */
}

function checkProductForm(){
  let productForm_button = document.querySelector('.product-form__submit');
  let productForm_atc = productForm_button.querySelector('.product-form__buttons-atc');
  let productForm_personalize = productForm_button.querySelector('.product-form__buttons-personalize');
  let productForm_personalize_text = productForm_button.querySelector('.product-form__buttons-personalize-text');
  let requiredFields = document.querySelectorAll('.option-set [required]');

  if(requiredFields && requiredFields.length){
    var hasEmptyField = false;
    for(f=0;f<requiredFields.length;f++){
      let field = requiredFields[f];
      if(field.value == ''){
        hasEmptyField = true;
        //field.closest('.product-form__input').classList.add('error');
        //return false;
      }else{
        field.classList.remove('error');
      }
    }
    if(hasEmptyField){
      productForm_atc.classList.add('hidden');
      productForm_personalize.classList.remove('hidden');
      productForm_personalize_text.classList.add('hidden');
      console.log('has empty field 2');
    }else{
      productForm_personalize.classList.add('hidden');
      productForm_atc.classList.remove('hidden');
      productForm_personalize_text.classList.remove('hidden');
      console.log('no empty field 2');
    }

    
  }
}
document.addEventListener('alpine:init', () => {
    Alpine.store('store', {
    })
})
function countDown_time(timeleft,message){
    // Calculating the days, hours, minutes and seconds left
    var days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
    var hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
    let op = '';
    if(days){op+=`${days}D : `;}
    if(hours){op+=`${hours}H : `;}
    if(minutes){op+=`${minutes}M : `;}
    if(seconds){op+=`${seconds}S`;}
    if(!op){op+=message?message:'Time Up'}
    return op;
}
function countDown(time, message ,callback) {
    // Run myfunc every second
    var countDown_interval = setInterval(() => {

    var now = new Date().getTime();
    var timeleft = time - now;
        
    callback(countDown_time(timeleft,message));
        
    // Display the message when countdown is over
    if (timeleft < 0) {
        clearInterval(countDown_interval);
        callback(message ? message : 'Time Up')
    }
    }, 1000);
    
}